// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PSmallDashOutlinedSvg from "@fishx/icons-svg/es/asn/PSmallDashOutlined";
import FishxIcon from '../components/FishxIcon';

var PSmallDashOutlined = function PSmallDashOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PSmallDashOutlinedSvg
  }));
};

PSmallDashOutlined.displayName = 'PSmallDashOutlined';
export default React.forwardRef(PSmallDashOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PSmallDashOutlined.js
// module id = 3635
// module chunks = 0